import styled from 'styled-components';

export const TableWrapper = styled.div`
  padding: 32px;
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead {
    background: #f8f9fa;
  }

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
  }
`;

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActivityCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AccountCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
`;

export const Row = styled.tr`
  background: ${({ read }) => (read ? '#f2f2f2' : '#ffffff')};
  transition: 0.2s ease;
`;

export const Title = styled.span`
  color: ${({ read }) => (read ? '#9ca3af' : '#111827')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  padding: 6px 16px;
`;

export const TypeTag = styled.div`
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: ${({ color }) => color?.background};
  color: ${({ color }) => color?.textColor};
  outline: ${({ color }) => color?.outline};
  outline-offset: -0.5px;
  word-wrap: break-word;
`;

export const ActionButton = styled.button`
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
`;

export const Checkbox = styled.input`
  cursor: pointer;
  border-radius: 2px;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  &:checked {
    background: var(--purple-900, #7367f0);
    border-color: var(--purple-900, #7367f0);
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 14px;
      height: 13px;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.99999 7.586L9.59599 2.9895L10.3035 3.6965L4.99999 9L1.81799 5.818L2.52499 5.111L4.99999 7.586Z" fill="white"/></svg>');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  &:focus {
    outline: 2px solid var(--purple-700, #5a5af0);
    outline-offset: 2px;
  }
`;
